import { render, staticRenderFns } from "./ClientInfoModal.vue?vue&type=template&id=377bddaa&scoped=true&"
import script from "./ClientInfoModal.vue?vue&type=script&lang=js&"
export * from "./ClientInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377bddaa",
  null
  
)

export default component.exports